const services = [
  {
    icon: 'ri-gift-line',
    title: 'Birthday Parties',
    description: 'Make your child\'s birthday unforgettable with a private train ride experience. Customizable packages available for all group sizes.',
    image: 'https://public.readdy.ai/ai/img_res/6d781351aa01a89b4d4f5b5691e52b1f.jpg'
  },
  {
    icon: 'ri-calendar-event-line',
    title: 'Holiday Events',
    description: 'Experience the magic of Christmas, Halloween, Easter, and other seasonal celebrations with specially themed train rides.',
    image: 'https://readdy.ai/api/search-image?query=Holiday%20themed%20train%20ride%20decorated%20with%20festive%20lights%20and%20seasonal%20decorations%20children%20enjoying%20celebration%20simple%20clean%20background%20warm%20magical%20atmosphere&width=600&height=400&seq=service002&orientation=landscape'
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Special Needs Rides',
    description: 'Fully accessible rides designed specifically for special needs children.',
    image: 'https://readdy.ai/api/search-image?query=Accessible%20train%20ride%20with%20special%20needs%20children%20and%20supportive%20caregivers%20inclusive%20environment%20with%20wheelchair%20access%20simple%20clean%20background%20caring%20atmosphere&width=600&height=400&seq=service003&orientation=landscape'
  },
  {
    icon: 'ri-community-line',
    title: 'Community Events',
    description: 'Perfect for school trips, community gatherings, and group outings. We accommodate large groups with advance booking.',
    image: 'https://readdy.ai/api/search-image?query=Community%20group%20event%20with%20diverse%20families%20and%20children%20on%20train%20ride%20together%20outdoor%20adventure%20simple%20clean%20background%20sunny%20day%20atmosphere&width=600&height=400&seq=service004&orientation=landscape'
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Charity Partnerships',
    description: 'We work with local charities and organizations to provide free or discounted rides for underprivileged children.',
    image: 'https://readdy.ai/api/search-image?query=Charity%20event%20with%20volunteers%20and%20children%20enjoying%20train%20ride%20together%20community%20support%20and%20giving%20back%20simple%20clean%20background%20heartwarming%20atmosphere&width=600&height=400&seq=service005&orientation=landscape'
  },
  {
    icon: 'ri-building-line',
    title: 'Corporate Events',
    description: 'Unique team-building experiences and family days for corporate groups. A memorable way to bring your team together.',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20family%20day%20event%20with%20employees%20and%20children%20on%20train%20ride%20team%20building%20activity%20simple%20clean%20background%20professional%20yet%20fun%20atmosphere&width=600&height=400&seq=service006&orientation=landscape'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-zinc-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 px-6 py-2 bg-red-600 rounded-full">
            <span className="text-white text-sm font-semibold uppercase tracking-wide">What We Offer</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Our Services
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto">
            From birthday celebrations to charity events, we create magical experiences for every occasion
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-black rounded-2xl overflow-hidden border border-white/10 hover:border-red-600 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-14 h-14 flex items-center justify-center bg-red-600 rounded-full">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4">
                  {service.title}
                </h3>
                <p className="text-white/70 leading-relaxed mb-6">
                  {service.description}
                </p>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 text-red-500 font-semibold hover:gap-4 transition-all cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}